<template>
  <section class="quote-info">
    <div class="box">
      <table class="table mg-b-10">
        <tr class="tr">
          <td>Insured Period</td>
          <td
            v-copy="formData.insurance_period"
            :class="{'green-tip':handleCompare('insurance_period')}">{{ formData.insurance_period}}</td>
        </tr>
        <tr class="tr">
          <td>Expected Insured Period</td>
          <td v-copy="formData.period_date">
            {{ formData.period_date }}
            <span
              v-if="formData.is_eff_dt_delay && formData.pcy_stts != 425"
              class="asap">(ASAP)</span>
          </td>
        </tr>
        <tr class="tr">
          <td>Total Price</td>
          <td
            v-if="showAmount"
            v-copy="amount"
            :class="{'green-tip':isChange}">{{ showAmount | formatMoney(2, true) }}</td>
        </tr>
        <tr class="tr">
          <td>Referrer</td>
          <td
            v-if="referrer"
          >
            <referrer-info :referrer="referrer"></referrer-info>
          </td>
        </tr>
        <tr
          v-if="formData.discount_str&&!isFina"
          class="tr">
          <td>Referrer Discount</td>
          <td>{{formData.discount_str}}</td>
        </tr>
        <tr
          v-if="!isEndorse"
          class="tr">
          <td>Policy Number </td>
          <td
            v-copy="formData.pcy_no"
            :class="{'green-tip':handleCompare('pcy_no')}">{{ formData.pcy_no  }}</td>
        </tr>
        <tr
          v-else
          class="tr">
          <td>Endorsement Number </td>
          <td
            v-copy="formData.endorser_no"
            :class="{'green-tip':handleCompare('endorser_no')}">{{ formData.endorser_no  }}</td>
        </tr>
        <tr class="tr">
          <td>Policy Reference Code </td>
          <td
            v-copy="formData.order_sn"
            :class="{'green-tip':handleCompare('order_sn')}">{{ formData.order_sn }}</td>
        </tr>
      </table>
    </div>
    <div
      v-if="excessList.length"
      class="box">
      <h3>Excess</h3>
      <table class="table">
        <tr class="tr th">
          <th>Item</th>
          <th>Amount</th>
        </tr>
        <tr
          v-for="(inItem, index) in excessList"
          :key="index + inItem.premium"
          class="tr">
          <td>{{ inItem.item }}</td>
          <td v-copy="inItem.premium">{{ inItem.premium }}</td>
        </tr>
        <tr class="tr">
          <td>Excess Remark</td>
          <td
            v-copy="changeLineData(formData.quote_remark)"
            :class="{'green-tip':handleCompare('quote_remark')}"
            v-html="changeLineData(formData.quote_remark)"></td>
        </tr>
      </table>
    </div>
    <div class="box">
      <div
        v-for="(excessItem, excessIndex) in coverageList.items"
        :key="'coverage' + excessIndex">
        <table
          v-if="excessItem.sub_items.length>0"
          class="table">
          <h3 :class="{'table-title':excessIndex>0}">{{ excessItem.sub_title? excessItem.sub_title: coverageList.title }}</h3>
          <tr
            v-if="excessIndex==0"
            class="tr th">
            <th>Item</th>
            <th>Information</th>
          </tr>
          <tr
            v-for="(subItem, subIndex) in excessItem.sub_items"
            :key="'coverage-' + excessIndex + subIndex"
            class="tr">
            <td>{{ subItem.item }}</td>
            <td v-copy="subItem.premium">{{ subItem.premium }}</td>
          </tr>
          <tr class="tr">
            <td>Coverage Remark</td>
            <td
              v-copy="changeLineData(formData.cvr_remark)"
              :class="{'green-tip':handleCompare('quote_remark')}"
              v-html="changeLineData(formData.cvr_remark)"></td>
          </tr>
        </table>
      </div>
    </div>

    <div class="box">
      <h3>Policy Detail</h3>
      <table class="table mg-b-10">
        <tr class="tr">
          <td>Expected Effective Date</td>
          <td
            v-copy="formData.pcy_cmnt_date"
            :class="{'green-tip':handleCompare('pcy_cmnt_date')}">{{ formData.pcy_cmnt_date }}</td>
        </tr>
        <tr class="tr">
          <td>Expected Expiry Date</td>
          <td
            v-copy="formData.pcy_expry_date"
            :class="{'green-tip':handleCompare('pcy_expry_date')}">{{ formData.pcy_expry_date }}</td>
        </tr>
        <tr class="tr">
          <td>Contract Period</td>
          <td
            v-copy="getAllOptionName24('period', formData.contr_prd)"
            :class="{'green-tip':handleCompare('contr_prd')}">{{ getAllOptionName24('period', formData.contr_prd) }}</td>
        </tr>
        <tr class="tr">
          <td>Building Age </td>
          <td
            v-copy="getAllOptionName24('bldg_ages', formData.bldg_age)"
            :class="{'green-tip':handleCompare('bldg_age')}">{{ getAllOptionName24('bldg_ages', formData.bldg_age) }}</td>
        </tr>
        <tr class="tr">
          <td>Total Contract Sum </td>
          <td
            v-copy="formData.tol_contr_sum"
            :class="{'green-tip':handleCompare('tol_contr_sum')}">{{ formData.tol_contr_sum }}</td>
        </tr>
        <tr class="tr">
          <td>Material Damage Coverage </td>
          <td
            v-copy="getOptionName('yesNoOptions', formData.mat_dam_cvr_ind)"
            :class="{'green-tip':handleCompare('mat_dam_cvr_ind')}">{{ getOptionName('yesNoOptions', formData.mat_dam_cvr_ind) }}</td>
        </tr>
        <tr class="tr">
          <td>Third Party Liability Coverage </td>
          <td
            v-copy="getOptionName('yesNoOptions', formData.tp_lia_cvr_ind)"
            :class="{'green-tip':handleCompare('tp_lia_cvr_ind')}">{{ getOptionName('yesNoOptions', formData.tp_lia_cvr_ind) }}</td>
        </tr>
        <tr class="tr">
          <td>Third Party Liability Limit</td>
          <td
            v-copy="getAllOptionName24('limit_of_liability', formData.tppd_limit_amt)"
            :class="{'green-tip':handleCompare('tppd_limit_amt')}">{{ getAllOptionName24('limit_of_liability', formData.tppd_limit_amt) }}</td>
        </tr>
        <tr class="tr">
          <td>Outdoor Work or Scaffolding Work</td>
          <td
            v-copy="getOptionName('yesNoOptions', formData.outdoor_wk_ind)"
            :class="{'green-tip':handleCompare('outdoor_wk_ind')}">{{ getOptionName('yesNoOptions', formData.outdoor_wk_ind) }}
          </td>
        </tr>
        <tr class="tr">
          <td>Total Contract Value of Outdoor Work and/or Scaffolding Work</td>
          <td
            v-copy="getAllOptionName24('scaffolding_wk', formData.scaffolding_wk)"
            :class="{'green-tip':handleCompare('scaffolding_wk')}">{{ getAllOptionName24('scaffolding_wk', formData.scaffolding_wk) }}</td>
        </tr>
        <tr class="tr">
          <td>Employee Compensation</td>
          <td
            v-copy="getOptionName('yesNoOptions', formData.employee_ind)"
            :class="{'green-tip':handleCompare('employee_ind')}">{{ getOptionName('yesNoOptions', formData.employee_ind) }}</td>
        </tr>
        <tr
          v-if="option_benefits.length>0"
          class="tr">
          <td>Optional Benefits</td>
          <td>
            <span
              v-for="(item,index) in option_benefits"
              :key="'extra'+index"
              v-copy="item.item">{{item.item}}<br></span>
          </td>
        </tr>
      </table>
    </div>

    <div class="box">
      <h3>Policyholder Detail</h3>
      <table class="table">
        <template v-if="formData.cust_typ == 1">
          <tr class="tr">
            <td>Title</td>
            <td
              v-copy="getOptionName('titleOptions', formData.isrd_title)"
              :class="{'green-tip':handleCompare('isrd_title')}">{{ getOptionName('titleOptions', formData.isrd_title) }}</td>
          </tr>
          <tr class="tr">
            <td>Last Name</td>
            <td
              v-copy="formData.isrd_lst_nm"
              :class="{'green-tip':handleCompare('isrd_lst_nm')}">{{ formData.isrd_lst_nm }}</td>
          </tr>
          <tr class="tr">
            <td>First Name</td>
            <td
              v-copy="formData.isrd_fst_nm"
              :class="{'green-tip':handleCompare('isrd_fst_nm')}">{{ formData.isrd_fst_nm }}</td>
          </tr>
          <tr class="tr">
            <td>HKID</td>
            <td
              v-copy="formData.id_no"
              :class="{'green-tip':handleCompare('id_no')}">{{ formData.id_no }}</td>
          </tr>
          <tr class="tr">
            <td>Mobile Number</td>
            <td
              v-copy="formData.mobile_no"
              :class="{'green-tip':handleCompare('mobile_no')}">{{ formData.mobile_no }}</td>
          </tr>
          <tr class="tr">
            <td>Email</td>
            <td
              v-copy="formData.email"
              :class="{'green-tip':handleCompare('email')}">
              {{ formData.email }}
              <email-tooltip :email="formData.email"></email-tooltip>
            </td>
          </tr>
          <tr class="tr">
            <td>Occupation</td>
            <td
              v-copy="formData.occ"
              :class="{'green-tip':handleCompare('occ')}">{{  formData.occ }}</td>
          </tr>
        </template>
        <template v-else>
          <tr class="tr">
            <td>Company Name</td>
            <td
              v-copy="formData.isrd_com_nm"
              :class="{'green-tip':handleCompare('isrd_com_nm')}">{{ formData.isrd_com_nm }}</td>
          </tr>
          <tr class="tr">
            <td>Business Registration Number</td>
            <td
              v-copy="formData.id_no"
              :class="{'green-tip':handleCompare('id_no')}">{{ formData.id_no }}</td>
          </tr>
          <!-- <div class="tr">
            <span>CI Number</span>
            <span>{{ formData.ci_no }}</span>
          </div> -->
          <tr class="tr">
            <td>Company Phone No.</td>
            <td
              v-copy="formData.phone_no"
              :class="{'green-tip':handleCompare('phone_no')}">{{ formData.phone_no }}</td>
          </tr>
          <tr class="tr">
            <td>Company Email</td>
            <td
              v-copy="formData.email"
              :class="{'green-tip':handleCompare('email')}">
              {{ formData.email }}
              <email-tooltip :email="formData.email"></email-tooltip>
            </td>
          </tr>
          <tr class="tr">
            <td>Nature of Business</td>
            <td
              v-copy="getAllOptionName24('industry', formData.bsns_nature_id)"
              :class="{'green-tip':handleCompare('bsns_nature_id')}">{{ getAllOptionName24('industry', formData.bsns_nature_id) }}</td>
          </tr>
        </template>
      </table>
    </div>

    <div class="box">
      <h3>Correspondence Address	</h3>
      <table class="table">
        <tr class="tr">
          <td>Room</td>
          <td
            v-copy="formData.addr_room"
            :class="{'green-tip':handleCompare('addr_room')}">{{ formData.addr_room }}</td>
        </tr>
        <tr class="tr">
          <td>Floor</td>
          <td
            v-copy="formData.addr_floor"
            :class="{'green-tip':handleCompare('addr_floor')}">{{ formData.addr_floor }}</td>
        </tr>
        <tr class="tr">
          <td>Block</td>
          <td
            v-copy="formData.addr_block"
            :class="{'green-tip':handleCompare('addr_block')}">{{ formData.addr_block }}</td>
        </tr>
        <tr class="tr">
          <td>Building / Estate</td>
          <td
            v-copy="formData.addr_building"
            :class="{'green-tip':handleCompare('addr_building')}">{{ formData.addr_building }}</td>
        </tr>
        <tr class="tr">
          <td>Street</td>
          <td
            v-copy="formData.addr_street"
            :class="{'green-tip':handleCompare('addr_street')}">{{ formData.addr_street }}</td>
        </tr>
        <tr class="tr">
          <td>District</td>
          <td
            v-copy="getAreaName('district', formData.addr_district)"
            :class="{'green-tip':handleCompare('addr_district')}">{{ getAreaName('district', formData.addr_district) }}</td>
        </tr>
        <tr class="tr">
          <td>Area</td>
          <td
            v-copy="getAreaName('area', formData.addr_area)"
            :class="{'green-tip':handleCompare('addr_area')}">{{ getAreaName('area', formData.addr_area) }}</td>
        </tr>
        <tr class="tr">
          <td>Country / Region</td>
          <td
            v-copy="getAreaName('region', formData.addr_region)"
            :class="{'green-tip':handleCompare('addr_region')}">{{ getAreaName('region', formData.addr_region) }}</td>
        </tr>
      </table>
    </div>
    <div class="box">
      <h2>Work Details</h2>
      <h3>Location of Works</h3>
      <table class="table">
        <tr class="tr">
          <td>Room</td>
          <td
            v-copy="formData.work_addr_room"
            :class="{'green-tip':handleCompare('work_addr_room')}">{{ formData.work_addr_room }}</td>
        </tr>
        <tr class="tr">
          <td>Floor</td>
          <td
            v-copy="formData.work_addr_floor"
            :class="{'green-tip':handleCompare('work_addr_floor')}">{{ formData.work_addr_floor }}</td>
        </tr>
        <tr class="tr">
          <td>Block</td>
          <td
            v-copy="formData.work_addr_block"
            :class="{'green-tip':handleCompare('work_addr_block')}">{{ formData.work_addr_block }}</td>
        </tr>
        <tr class="tr">
          <td>Building / Estate</td>
          <td
            v-copy="formData.work_addr_building"
            :class="{'green-tip':handleCompare('work_addr_building')}">{{ formData.work_addr_building }}</td>
        </tr>
        <tr class="tr">
          <td>Street</td>
          <td
            v-copy="formData.work_addr_street"
            :class="{'green-tip':handleCompare('work_addr_street')}">{{ formData.work_addr_street }}</td>
        </tr>
        <tr class="tr">
          <td>District</td>
          <td :class="{'green-tip':handleCompare('work_addr_district')}">{{ getAreaName('district', formData.work_addr_district) }}</td>
        </tr>
        <tr class="tr">
          <td>Area</td>
          <td v-copy="formData.work_addr_area">{{ getAreaName('area', formData.work_addr_area) }}</td>
        </tr>
        <tr class="tr">
          <td>Country / Region</td>
          <td
            v-copy="getAreaName('region', formData.work_addr_region)"
            :class="{'green-tip':handleCompare('work_addr_region')}">{{ getAreaName('region', formData.work_addr_region) }}</td>
        </tr>
        <tr class="tr">
          <td>Occupied as</td>
          <td
            v-copy="getAllOptionName24('occupied_as', formData.occupied_as)"
            :class="{'green-tip':handleCompare('occupied_as')}">{{ getAllOptionName24('occupied_as', formData.occupied_as) }}</td>
        </tr>
      </table>
    </div>
    <div class="box">
      <h3>Sub-Contractor (if any)</h3>
      <table class="table">
        <tr class="tr">
          <td>Sub Contractors (if any)</td>
          <td
            v-copy="formData.sub_contractors"
            :class="{'green-tip':handleCompare('sub_contractors')}">{{ formData.sub_contractors }}</td>
        </tr>
        <tr class="tr">
          <td>Property Management Company (If any)</td>
          <td
            v-copy="formData.property_management_company"
            :class="{'green-tip':handleCompare('property_management_company')}">{{ formData.property_management_company }}</td>
        </tr>
      </table>
    </div>

    <div class="box">
      <h3>Remark(s)</h3>
      <table class="table">
        <tr class="tr">
          <td>Remark</td>
          <td
            v-copy="changeLineData(formData.cs_manual_remark)"
            :class="{'green-tip':handleCompare('cs_manual_remark')}"
            v-html="changeLineData(formData.cs_manual_remark)"></td>
        </tr>
      </table>
    </div>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import OMath from '@/utils/math'
import ReferrerInfo from '@/views/records/policy/components/info/referrer-info'

export default {
  name: 'DecorationPolicyInfo',
  components: {ReferrerInfo},
  mixins: [MixinOptions, MixinFormat],
  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    preFormData: {
      type: Object,
      default: () => ({})
    },
    showAmount: {
      type: [String,Number],
      default: ''
    },
    isChange: {
      type: Boolean,
      default: false
    },
  },
  computed:{
    isFina(){
      let {merchant_platform} = this.formData||{}
      return merchant_platform==2
    },
    amount(){
      return  OMath.formatMoney(this.showAmount, 2,true)
    },
    referrer(){
      let {referrer} = this.formData||{}
      return referrer||{}
    },
    sidebarPremium() {
      let {quote_coverage_list={}} =this.formData||{}
      if(!quote_coverage_list) {
        return []
      }
      let { sidebar_premium=[]} =quote_coverage_list||{}
      if(sidebar_premium.length<=0)return  []
      return sidebar_premium
    },
    option_benefits(){
      let {quote_coverage_list={}} = this.formData||{}
      let {more_benefit={}} = quote_coverage_list||{}
      let {sub_items={}} = more_benefit||{}
      let arr =[]
      if(sub_items){
        arr = Object.entries(sub_items).map(item=>item[1])
      }
      return arr
    },
    isEndorse(){
      return [30,40].includes(this.formData.type)
    },
    showEndorsementPremium() {
      const {type} = this.formData
      return [30, 40, 50].includes(type)
    },
    excessList(){
      let {quote_coverage_list} = this.formData||{}
      let {excess} = quote_coverage_list||{}
      let {items} = excess||{}
      if(items){
        return items[0].sub_items
      }
      return  []
    },
    coverageList(){
      let {quote_coverage_list} = this.formData||{}
      let {coverage={}} = quote_coverage_list||{}
      return  coverage
    },
    compareList(){
      let {type} = this.formData||{}
      let nowData = this.formData||{}
      let pre = this.preFormData||{}
      if(type!=50)return []
      let arr =  Object.keys(nowData).reduce((result,key)=>{
        if(nowData[key]!=pre[key]){
          result.push(key)
        }
        return result
      },[])
      return arr||[]
    }
  },
  methods:{
    handleCompare(filed){
      let {type} = this.formData
      if(type!=50) return false
      return  this.compareList.includes(filed)?true:false
    },
  }
}
</script>
<style lang="scss" scoped>
.quote-info{
  .box {
    margin-bottom: 15px;
  }
   .title {
    padding: 15px 0;
  }
  .table-title {
    display: inline-block;
    padding-bottom: 2px;
    padding-left: 5px;
    font-size: 12px;
    font-weight: bold;
    color: #909399;
    line-height: 15px;
  }
  .asap{
    font-weight: bold;
    color: black;
    margin-left: 5px;
  }
}
</style>
